var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tables-settings layout",
      class: {
        empty: _vm.isEmpty,
      },
    },
    [
      _c("div", { staticClass: "layout-title" }, [_vm._v("Настройки")]),
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c(
        "div",
        { staticClass: "tables-settings__tabs" },
        [
          _c("c-tabs", {
            attrs: {
              items: [
                {
                  label: "Общие настройки",
                  value: "/index.php?r=total-settings%2Findex",
                  link: "/index.php?r=total-settings%2Findex",
                },
                {
                  label: "Настройки таблиц",
                  value: "tables-settings",
                  disabled: !_vm.userHavePermissionForTablesSettings,
                },
                {
                  label: "Автоматическое создание ведомостей",
                  value: "auto-creation-calc-sheets",
                  disabled: !_vm.userHavePermissionForAutoCreationCalcSheets,
                },
              ],
              "with-routing": "",
            },
          }),
        ],
        1
      ),
      _c("condition-sidesheet", {
        ref: "typeModal",
        attrs: { periods: _vm.periods },
        on: {
          submitted: _vm.modalIsSubmitted,
          "calculation-sheet-is-created": _vm.calculationSheetIsCreated,
          "delete-item": _vm.deleteItem,
        },
      }),
      !_vm.loading
        ? _c("div", { staticClass: "tables-settings__content" }, [
            _vm.inited
              ? _c("div", { staticClass: "row tables-settings__actions" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col col-12 col-md-8 col-lg-6 tables-settings__search",
                    },
                    [
                      _c("c-select", {
                        attrs: {
                          type: "select",
                          label: "Филиал",
                          multiple: true,
                          searchable: true,
                          placeholder: "Все",
                          items: _vm.collections.filial,
                          checkbox: true,
                          "checkbox-value": _vm.globalFilters.filialReverse,
                          "checkbox-type": "icon",
                          "checkbox-tooltip": {
                            disabledText:
                              "Фильтр по всем значениям в справочнике, кроме выбранных",
                            activeText:
                              "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                            notActiveText:
                              "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                          },
                          useCustomColors: true,
                        },
                        on: {
                          checkboxChange: function ($event) {
                            _vm.globalFilters.filialReverse = $event
                          },
                        },
                        model: {
                          value: _vm.globalFilters.filial,
                          callback: function ($$v) {
                            _vm.$set(_vm.globalFilters, "filial", $$v)
                          },
                          expression: "globalFilters.filial",
                        },
                      }),
                      _c("c-button-2", {
                        attrs: { label: "Применить", color: "primary" },
                        on: { click: _vm.applyFilters },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col col-12 col-md-4 col-lg-6 tables-settings__add",
                    },
                    [
                      _c("c-button", {
                        attrs: {
                          label: "Добавить условие",
                          icon: {
                            icon: "plus",
                            color: "blue",
                          },
                        },
                        on: { click: _vm.addTableSettings },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "tables-settings__list" },
              [
                _c("tables-settings-table", {
                  attrs: {
                    inited: _vm.inited,
                    items: _vm.items,
                    empty: _vm.isEmpty,
                    "sort-by": _vm.sortBy,
                    loading: _vm.loading,
                  },
                  on: {
                    nextPage: _vm.nextPage,
                    sort: _vm.sort,
                    remove: _vm.removeTableSettings,
                    "edit-condition": _vm.editCondition,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "b-modal",
        {
          staticClass: "calculation-modal",
          attrs: {
            id: "create-user-employee-modal-success",
            size: "custom-size",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            { staticClass: "create-user-success-modal" },
            [
              _c(
                "svg",
                {
                  staticClass: "create-user-success-modal-close",
                  attrs: {
                    width: "15",
                    height: "16",
                    viewBox: "0 0 15 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      _vm.active = false
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                      fill: "#8E9CBB",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                      fill: "#8E9CBB",
                    },
                  }),
                ]
              ),
              _vm._v(" Первая ведомость на период "),
              _c("b", [_vm._v(_vm._s(_vm.calculationSheet.period))]),
              _vm._v(" создана."),
              _c("br"),
              _c("br"),
              _vm._v(" Расчётная ведомость "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "?r=redesign#/calculation-sheets/" +
                      _vm.calculationSheet.id,
                  },
                },
                [
                  _vm._v(
                    "№" +
                      _vm._s(_vm.calculationSheet.id) +
                      " " +
                      _vm._s(_vm.calculationSheet.dates)
                  ),
                ]
              ),
              _vm._v(". "),
              _c("c-button", {
                staticClass: "close-action",
                attrs: { size: "large", label: "Закрыть" },
                on: {
                  click: function ($event) {
                    _vm.active = false
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          !_vm.loading
            ? _c("display-shown-items-count", {
                attrs: {
                  "total-items-count": _vm.totalItemsCount,
                  "shown-items-count": _vm.items.length,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.loading || _vm.loadingMore
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.loading || _vm.loadingMore,
              height: "400",
            },
          })
        : _vm._e(),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }